import { DelegationService } from '../../../../delegate-slider/services/delegation.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { PanelList } from '../../../../shared/models/panel-list';
import { DelegateDtoDisplay } from '../../../models/delegateDtoDisplay';
import { DelegationLibraryConstants } from '../../../../delegate/delegation-library-constants';
import { UsersService } from '../../../../shared/services/users.service'
import { DelegatToUpdate } from '../../../models/updateDelegate';
import { MessageService } from 'primeng/api';
import { catchError, skip, Subject, takeUntil, throwError } from 'rxjs';
import { DelegationInteractionService } from '../../../../delegate-slider/services/delegation-interaction-service';
import { DocumentDisplayInformation } from '../../../../delegate-slider/models/documentDisplayInformation';

@Component({
  selector: 'app-my-delegations',
  templateUrl: './my-delegations.component.html',
  styleUrls: ['./my-delegations.component.scss'],
})
export class MyDelegationsComponent implements OnInit, OnDestroy{
  documentDetailInformation: DocumentDisplayInformation[] = [];
  docNumberList: any[] = [];
  displayList: DocumentDisplayInformation[] = [];
  isActiveDelegates: boolean = true;
  myDelegationsData: PanelList = {
    lists: [],
    filters: [],
    sort: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: true,
    clearSelection:false,
    isCheckBoxContainsDisable: false,
  };
  isModalVisable = false;
  myDelegations: DelegateDtoDisplay[] = [];
  userList: any = [];
  userData: any = [];
  showInactiveCheckBoxClicked = false;
  delegationReassignTitle: string =
    DelegationLibraryConstants.DelegationReassignTitle;
  delegationEndTitle: string = DelegationLibraryConstants.DelegationEndTitle;
  PopupHeader: string =
    DelegationLibraryConstants.DelegationReassignPopupHeader;
  PopupText: string = DelegationLibraryConstants.DelegationReassignPopupText;
  delegateToValidationText: string = DelegationLibraryConstants.Delegate_DelegateTo_Required;
  destroy$: Subject<boolean> = new Subject<boolean>();
  valueField: string = 'value';
  labelField: string = 'name';
  delegatToUpdate: DelegatToUpdate = new DelegatToUpdate();
  loggedInUser: string =
    sessionStorage['puid'] != null ? sessionStorage['puid'] : null;
  isConfirmBtnDisable = true;
  isDelegateRequired: boolean = false;
  loader = true;
  showPanelLoader = false;
  firstLoad = true;

  constructor(
    private delegationService: DelegationService,
    private messageService: MessageService,
    private usersService: UsersService,
    private cd: ChangeDetectorRef,
    private delegationInteractionService: DelegationInteractionService
  ) {}

  ngOnInit(): void {
    this.initialize();
    this.getDelegations();
    this.delegationInteractionService.saveDelegation$
      .pipe(takeUntil(this.destroy$), skip(1))
      .subscribe((isClose) => {
        setTimeout(() => {
          this.getDelegations();
        }, 2000);
      });

    this.delegationInteractionService.endDelegation$
      .subscribe((isUpdate) => {
          this.endDelegation();
      });
  }

  initialize() {
    // To load users data
    this.userList = [];
    this.usersService.getUsersForDelegation().pipe(takeUntil(this.destroy$)).subscribe((users) => {
      if (users) {
        const delegationToUsers = Array.isArray(users.delegationTo) ? [...users.delegationTo] : [];
        const filteredUsers = this.loggedInUser
          ? delegationToUsers.filter((x: any) => x?.puid !== this.loggedInUser)
          : delegationToUsers;

        this.userData = filteredUsers
        for (let dataItem of this.userData) {
          if (dataItem) {
            this.userList.push({
              value: dataItem.name,
              name: dataItem.name,
            });
          }
        }
      }
    });
  }

  getDelegations() {
    if(!this.firstLoad)
    this.showPanelLoader = true;
    this.delegationService
      .getDelegationsForMyDelegationTab(this.isActiveDelegates)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: DelegationLibraryConstants.Severity_Err,
            summary: `${DelegationLibraryConstants.Get_Delegations_Failure}`,
          });
          this.firstLoad? this.loader = false: this.showPanelLoader = false;
          return throwError(() => err);
        }),takeUntil(this.destroy$)
      )
      .subscribe((delegations) => {
        if (delegations.length > 0) {
          this.myDelegationsData.lists = delegations;
          delegations.some((obj: any) => obj.isActive === 'No')
            ? (this.myDelegationsData.isCheckBoxContainsDisable = true)
            : (this.myDelegationsData.isCheckBoxContainsDisable = false);
          this.myDelegations = delegations;
          this.constructDataForDisplay();
        } else {
          this.myDelegationsData.lists = [];
          this.firstLoad? this.loader = false: this.showPanelLoader = false;
        }
      });

      //Moving these two methods outside the subscripton because we need to load the filters and sortby along with header in the UI by default.      
      this.addFilters();
      this.addSorting();
  }

  constructDataForDisplay() {
    this.myDelegations
      .map((del) => del.documentNumbers)
      .forEach((docNumber) => {
        if (docNumber != null) {
          docNumber.forEach((number) => {
            if (!this.docNumberList.includes(number) && number != null) {
              this.docNumberList.push(number);
            }
          });
        }
      });
    if (this.docNumberList) {
      this.getDocumentTitlesWithIds();
    } else {
      this.firstLoad? this.loader = false: this.showPanelLoader = false;
    }
  }

  getDocumentTitlesWithIds() {
    this.delegationService
      .getLatestDocumentDetail(this.docNumberList)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: DelegationLibraryConstants.Severity_Err,
            summary: `${DelegationLibraryConstants.Get_Document_Titles_Failure}`,
          });
          this.firstLoad? this.loader = false: this.showPanelLoader = false;
          return throwError(() => err);
        }),takeUntil(this.destroy$)
      )
      .subscribe((linkedItemDisplay) => {
        this.documentDetailInformation = linkedItemDisplay;
        this.myDelegations.forEach((delegate) => {
          if (delegate.scopeName == 'Document') {
            delegate.documentDisplayInformations = [];
            this.documentDetailInformation.forEach((documentDetail) => {
              delegate.documentNumbers.forEach((docNumber) => {
                if (documentDetail.number == docNumber && docNumber != null) {
                  delegate.documentDisplayInformations?.push(documentDetail);
                }
              });
            });
          }
        });
        this.firstLoad? this.loader = false: this.showPanelLoader = false;
        this.myDelegationsData = {...this.myDelegationsData};
      });
  }
  addFilters() {
    this.myDelegationsData.filters = [];
    this.myDelegationsData.enableFilter = true;
    this.myDelegationsData.filters?.push({
      filterDisplayName: 'Scope',
      filterFieldName: 'scopeName',
    });
    this.myDelegationsData.filters?.push({
      filterDisplayName: 'Assignment',
      filterFieldName: 'assignmentNames',
    });
    this.myDelegationsData.filters?.push({
      filterDisplayName: 'Delegate To',
      filterFieldName: 'delegateTo',
    });
  }

  addSorting() {
    this.myDelegationsData.sort = [];
    this.myDelegationsData.enableSort = true;
    this.myDelegationsData.sort?.push({
      sortFieldDisplayName: 'Scope',
      sortFieldName: 'scopeName',
    });
    this.myDelegationsData.sort?.push({
      sortFieldDisplayName: 'Assignment',
      sortFieldName: 'assignmentNames',
    });
    this.myDelegationsData.sort?.push({
      sortFieldDisplayName: 'Delegate To',
      sortFieldName: 'delegateTo',
    });
  }

  showInactiveDelegates() {
    this.firstLoad = false;
    this.isActiveDelegates = !this.isActiveDelegates;
    this.getDelegations();
    this.myDelegationsData.clearSelection = true;
  }

  reassignDelegation() {
    this.isDelegateRequired = false;
    this.isModalVisable = true;
  }

  cancelClick(): void {    
    this.delegatToUpdate.delegateTo = [];
    this.isModalVisable = false;
    this.isDelegateRequired = false;
  }

  selectedDelegates(selectedDelegates: any) {
    if (selectedDelegates?.length) {
      this.isConfirmBtnDisable = false;
      this.delegatToUpdate.delegateIds = [];
      const unique = selectedDelegates.filter((element: any) => {
        const isDuplicate = this.delegatToUpdate.delegateIds.includes(
          element.delegateId
        );

        if (!isDuplicate) {
          this.delegatToUpdate.delegateIds.push(element.delegateId);
          return true;
        }
        return false;
      });
    } else {
      this.isConfirmBtnDisable = true;
    }
  }

  confirmClick() {

    if(this.delegatToUpdate?.delegateTo?.length > 0){
      this.isDelegateRequired = false;
      this.delegationService
        .updateDelegation(this.delegatToUpdate)
        .pipe(
          catchError((err) => {
            this.isModalVisable = false;
            this.messageService.add({
              severity: DelegationLibraryConstants.Severity_Err,
              summary: `${DelegationLibraryConstants.Delegate_Creation_Failed}`,
            });
            return throwError(() => err);
          }),takeUntil(this.destroy$)
        )
        .subscribe((serviceData) => {
          this.messageService.add({
            severity: DelegationLibraryConstants.Severity_Success,
            summary: DelegationLibraryConstants.Reassign_Completed_Success,
          });
          this.isModalVisable = false;
          setTimeout(()=>{
            this.getDelegations();}
             ,2000)
            this.isConfirmBtnDisable = true;
            this.myDelegationsData.clearSelection = true;
            this.delegatToUpdate.delegateTo = [];
        });
    } else {
      this.isDelegateRequired = true;
    }
  }

  onDelegateToChange() {
    if (this.delegatToUpdate?.delegateTo?.length > 0) {
      this.isDelegateRequired = false;
    }
  }

  ngOnDestroy = () => {
    this.destroy$.next(true);
    this.destroy$.unsubscribe(); 
   }

   endDelegationConfirmation(){
    if(this.delegatToUpdate?.delegateIds.length > 0)
      this.delegationInteractionService.openConfirmationDialogeForEndDelegation();
   }

   endDelegation(){
    if(this.delegatToUpdate?.delegateIds != undefined && this.delegatToUpdate?.delegateIds.length > 0){
      this.isDelegateRequired = false;
      this.delegationService
        .updateEndDelegation(this.delegatToUpdate.delegateIds)
        .pipe(
          catchError((err) => {
            this.messageService.add({
              severity: DelegationLibraryConstants.Severity_Err,
              summary: `${DelegationLibraryConstants.Delegate_End_Failed}`,
            });
            return throwError(() => err);
          }),takeUntil(this.destroy$)
        )
        .subscribe((serviceData) => {
          this.messageService.add({
            severity: DelegationLibraryConstants.Severity_Success,
            summary: DelegationLibraryConstants.End_Delegation_Completed_Success,
          });
          setTimeout(()=>{
            this.getDelegations();}
             ,2000)
            this.isConfirmBtnDisable = true;
            this.myDelegationsData.clearSelection = true;
            this.delegatToUpdate.delegateTo = [];
        });
    } else {
      this.isDelegateRequired = true;
    }
   }
}
